import { Component } from '@angular/core';
import { AuthService } from '../../../shared/auth/auth.service';
import { LabelComponent } from '../../../shared/components/form/label/label.component';
import { CheckboxComponent } from '../../../shared/components/form/input/checkbox.component';
import { ButtonComponent } from '../../../shared/components/ui/button/button.component';
import { InputFieldComponent } from '../../../shared/components/form/input/input-field.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AuthPageLayoutComponent } from '../../../core/layout/auth-page-layout/auth-page-layout.component';

@Component({
  selector: 'app-sign-in',
  imports: [
    AuthPageLayoutComponent,
    LabelComponent,
    CheckboxComponent,
    ButtonComponent,
    InputFieldComponent,
    RouterModule,
    FormsModule
],
  templateUrl: './sign-in.component.html',
  styles: ``
})
export class SignInComponent {
  showPassword = false;
  isChecked = false;

  email = '';
  password = '';
  
  constructor(
    private authService: AuthService
  ) {}

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  onSignIn(): void {
    console.log('Email:', this.email);
    console.log('Password:', this.password);
    console.log('Remember Me:', this.isChecked);

    this.authService.login({
      redirectUri: window.location.origin
    });
  }
}